// index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./print.css";
// Preload Layout and commonStyles to prevent webpack chunk loading errors
// These are used by almost all pages, so importing them here ensures they're in the main bundle
// This prevents webpack from creating malformed shared chunks with invalid names
import "./components/Layout";
import "./styles/commonStyles";

// Global error handler for unhandled JavaScript errors
window.addEventListener('error', (event) => {
  console.error('[GLOBAL ERROR]', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
  
  // Store error for debugging (visible in console)
  window.__lastError = {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error?.toString(),
    stack: event.error?.stack,
    timestamp: new Date().toISOString()
  };
}, true);

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error('[UNHANDLED PROMISE REJECTION]', {
    reason: event.reason,
    promise: event.promise
  });
  
  // Store error for debugging
  window.__lastUnhandledRejection = {
    reason: event.reason?.toString() || String(event.reason),
    stack: event.reason?.stack,
    timestamp: new Date().toISOString()
  };
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
